import styled from 'styled-components';

interface StyleProps {
  backgroundColor?: string;
  position?: 'top' | 'bottom';
  color?: string;
}

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  background-color: #ffffff;
  margin-bottom: 8px;
`;

const Title = styled.div`
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #616161;
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e1e2e4;
`;

const RowCategory = styled.div`
  width: 110px;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
  display: flex;
  align-items: center;
`;

const RowContent = styled.div`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  text-align: left;
`;

const BlueSmallText = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #008aff;
  margin-top: 8px;
`;

const LeftCell = styled.div`
  width: fit-content;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
`;

const RightCell = styled.div`
  width: fit-content;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

const DivRow = styled.div<StyleProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${(props) => {
    if (props.position === 'top') return '16px 16px 10px 16px';
    if (props.position === 'bottom') return '10px 16px 16px 16px';
    return '10px 16px';
  }};
  background-color: ${(props) => props.backgroundColor || 'none'};
  border-top-left-radius: ${(props) =>
    props.position === 'top' ? '16px' : '0'};
  border-top-right-radius: ${(props) =>
    props.position === 'top' ? '16px' : '0'};
  border-bottom-left-radius: ${(props) =>
    props.position === 'bottom' ? '16px' : '0'};
  border-bottom-right-radius: ${(props) =>
    props.position === 'bottom' ? '16px' : '0'};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #e5e8ea;
  border-radius: 16px;
  overflow: hidden;
`;

const InfoCell = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: ${(props) => {
    if (props.position === 'top') return '16px 16px 10px 16px';
    if (props.position === 'bottom') return '10px 16px 16px 16px';
    return '10px 16px';
  }};
  background-color: ${(props) => props.backgroundColor || 'none'};
  border-right: 1px solid #e5e8ea;
  border-bottom: 1px solid #e5e8ea;

  &:nth-child(2n) {
    border-right: none;
  }

  &:nth-last-child(-n + 2) {
    border-bottom: none;
  }
`;

const CellTitle = styled.div<StyleProps>`
  font-size: 13px;
  color: ${(props) => props.color || '#616161'};
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;

const CellContent = styled.div<StyleProps>`
  font-size: 14px;
  color: ${(props) => props.color || '#222222'};
  font-weight: 700;
`;

const InterestButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const InterestButton = styled.div`
  flex: 1;
  padding: 18px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
`;

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background-color: rgba(112, 115, 124, 0.16);
`;

export const s = {
  Div,
  Title,
  Table,
  TableRow,
  RowCategory,
  RowContent,
  BlueSmallText,
  LeftCell,
  RightCell,
  DivRow,
  Grid,
  InfoCell,
  CellTitle,
  CellContent,
  InterestButtonBox,
  InterestButton,
  Divider,
};
